import type { ModalProps } from '@components/Modals/Interview';
import Modal from '@components/Modals/Interview';

export type SettingCheckModalProps = ModalProps & {
  open?: boolean;
};

const SettingCheckModal = ({
  onClickCancel,
  onClickConfirm,
  open,
}: SettingCheckModalProps) => {
  if (!open) return null;

  return (
    <Modal onClickCancel={onClickCancel} onClickConfirm={onClickConfirm}>
      환경 체크가 정상적으로 완료되지 않았습니다.{'\n'}
      화상면접이 정상적으로 진행되지 못할 수 있습니다.{'\n\n'}
      그래도 계속 진행하시겠습니까?
    </Modal>
  );
};

export default SettingCheckModal;
